export const actionTypes = {
  GET_CONSIGNED_ORDER: "GET_CONSIGNED_ORDER",
  SET_CONSIGNED_ORDER: "SET_CONSIGNED_ORDER",

  GET_CO_BY_ID: "GET_CO_BY_ID",
  SET_CO_BY_ID: "SET_CO_BY_ID",

  GET_PRODUCT_OPTIONS: "GET_PRODUCT_OPTIONS",
  SET_PRODUCT_OPTIONS: "SET_PRODUCT_OPTIONS",

  GET_CONSIGNED_PARTNERS: "GET_CONSIGNED_PARTNERS",
  SET_CONSIGNED_PARTNERS: "SET_CONSIGNED_PARTNERS",

  GET_ORDER_STATUS: "GET_ORDER_STATUS",
  SET_ORDER_STATUS: "SET_ORDER_STATUS",
  
  GET_PAYMENTTERM_OPTIONS: "GET_PAYMENTTERM_OPTIONS",
  SET_PAYMENTTERM_OPTIONS: "SET_PAYMENTTERM_OPTIONS",

  APPROVE_REJECT_ORDER: "APPROVE_REJECT_ORDER",
  SEND_ORDER_TO_PUZZLE: "SEND_ORDER_TO_PUZZLE",
  GET_ORDERS_PUZZLE: "GET_ORDERS_PUZZLE",

  SAVE_CONSIGNED_ORDER: "SAVE_CONSIGNED_ORDER",
  UPDATE_ORDER_STATUS: "UPDATE_ORDER_STATUS",
  BULK_STATUS_UPDATE: "BULK_STATUS_UPDATE",

  GET_AUTO_SYNC_SETTINGS: "GET_AUTO_SYNC_SETTINGS",
  SET_AUTO_SYNC_SETTINGS: "SET_AUTO_SYNC_SETTINGS",
  TOGGLE_AUTO_SYNC: "TOGGLE_AUTO_SYNC",

  SET_PUZZLE_LOADER: "SET_PUZZLE_LOADER",
  SET_CONSIGNED_ORDER_LOADER: "SET_CONSIGNED_ORDER_LOADER",
  SET_EDIT_CONSIGNED_ORDER_LOADER: "SET_EDIT_CONSIGNED_ORDER_LOADER",
  SET_AUTO_SYNC_LOADER: "SET_AUTO_SYNC_LOADER"
};

export const actions = {
  getConsignedOrder: (payload) => ({
    type: actionTypes.GET_CONSIGNED_ORDER,
    payload: payload,
  }),

  setConsignedOrder: (payload) => ({
    type: actionTypes.SET_CONSIGNED_ORDER,
    payload: payload,
  }),

  getConsignedOrderById: (payload) => ({
    type: actionTypes.GET_CO_BY_ID,
    payload: payload,
  }),

  setConsignedOrderById: (payload) => ({
    type: actionTypes.SET_CO_BY_ID,
    payload: payload,
  }),

  getProductOptions: (payload) => ({
    type: actionTypes.GET_PRODUCT_OPTIONS,
    payload: payload,
  }),

  setProductOptions: (payload) => ({
    type: actionTypes.SET_PRODUCT_OPTIONS,
    payload: payload,
  }),

  getPartners: (payload) => ({
    type: actionTypes.GET_CONSIGNED_PARTNERS,
    payload: payload,
  }),

  setPartners: (payload) => ({
    type: actionTypes.SET_CONSIGNED_PARTNERS,
    payload: payload,
  }),

  getOrderStatuses: (payload) => ({
    type: actionTypes.GET_ORDER_STATUS,
    payload: payload,
  }),

  setOrderStatuses: (payload) => ({
    type: actionTypes.SET_ORDER_STATUS,
    payload: payload,
  }),

  getPaymentTermOptions: (payload) => ({
    type: actionTypes.GET_PAYMENTTERM_OPTIONS,
    payload: payload,
  }),

  setPaymnentTermOptions: (payload) => ({
    type: actionTypes.SET_PAYMENTTERM_OPTIONS,
    payload: payload,
  }),

  approveRejectOrder: (payload) => ({
    type: actionTypes.APPROVE_REJECT_ORDER,
    payload
  }),

  sendOrderToPuzzle: (payload) => ({
    type: actionTypes.SEND_ORDER_TO_PUZZLE,
    payload
  }),

  getOrdersPuzzle: (payload) => ({
    type: actionTypes.GET_ORDERS_PUZZLE,
    payload
  }),

  setPuzzleLoader: (payload) => ({
    type: actionTypes.SET_PUZZLE_LOADER,
    payload
  }),

  setConsignedOrderLoader: (payload) => ({
    type: actionTypes.SET_CONSIGNED_ORDER_LOADER,
    payload
  }),

  setEditConsignedOrderLoader: (payload) => ({
    type: actionTypes.SET_EDIT_CONSIGNED_ORDER_LOADER,
    payload
  }),

  saveConsignedOrder: (payload) => ({
    type: actionTypes.SAVE_CONSIGNED_ORDER,
    payload
  }),

  updateOrderStatus: (payload) => ({
    type: actionTypes.UPDATE_ORDER_STATUS,
    payload
  }),

  bulkStatusUpdate: (payload) => ({
    type: actionTypes.BULK_STATUS_UPDATE,
    payload
  }),

  getAutoSyncSettings: (payload) => ({
    type: actionTypes.GET_AUTO_SYNC_SETTINGS,
    payload
  }),

  setAutoSyncSettings: (payload) => ({
    type: actionTypes.SET_AUTO_SYNC_SETTINGS,
    payload
  }),

  toggleAutoSync: (payload) => ({
    type: actionTypes.TOGGLE_AUTO_SYNC,
    payload
  }),

  setAutoSyncLoader: (payload) => ({
    type: actionTypes.SET_AUTO_SYNC_LOADER,
    payload
  })
};
